import { AttributeTypeHeight } from '@modules/wholesale/productCardConfigSettings/product-settings-constants'

const calculateAttributesTotalHeight = (currentViewConfig = []) => {
  const height = currentViewConfig?.reduce((total, item) => {
    const { showLabel, displayType, hasDoubleSpace } = item
    // calculate height of content text and
    // height of label if exists plus margin
    const contentHeight = hasDoubleSpace
      ? AttributeTypeHeight[displayType] * 2
      : AttributeTypeHeight[displayType]
    const temp = showLabel
      ? contentHeight +
        AttributeTypeHeight.LABEL_ITEM +
        AttributeTypeHeight.WITH_LABEL_PADDING
      : contentHeight + AttributeTypeHeight.WITHOUT_LABEL_PADDING
    return total + temp
  }, 0)
  return height
}

export default calculateAttributesTotalHeight
